export enum Status {
  positive = 'positive',
  negative = 'negative',
  neutral = 'neutral',
}
